import { Component } from "react"

class Error404 extends Component {
    render() {
        return (<h1>404 Not Found!</h1>)
    }
}
export default Error404